// Unpublished Work © 2023 Deere & Company.
import { GridSortModel } from "@mui/x-data-grid-pro";
import { createContext, ReactElement, useState } from "react";
import { AllHandlingUnitsFilter } from "../../components/handlingUnitGrid/HandlingUnitGrid";

export type HandlingUnitListContextProps = {
  setHandlingUnitListContext: (value: HandlingUnitListContextState) => void;
  getHandlingUnitListContext: () => HandlingUnitListContextState | undefined;
};

export type HandlingUnitListContextState = {
  filter: AllHandlingUnitsFilter;
  tabIndex: number;
  pageNumber: number;
  pageSize: number;
  sortModel: GridSortModel;
};

export const HandlingUnitListContext =
  createContext<HandlingUnitListContextProps>({
    getHandlingUnitListContext: () => undefined,
    setHandlingUnitListContext: () => {},
  });

export const HandlingUnitListProvider = ({
  children,
}: {
  children: ReactElement;
}) => {
  const [huListState, setHuListState] = useState<
    HandlingUnitListContextState | undefined
  >(undefined);

  const setHandlingUnitListContext = (value: HandlingUnitListContextState) => {
    setHuListState(value);
  };

  const getHandlingUnitListContext = ():
    | HandlingUnitListContextState
    | undefined => huListState;

  return (
    <HandlingUnitListContext.Provider
      value={{
        setHandlingUnitListContext,
        getHandlingUnitListContext,
      }}
    >
      {children}
    </HandlingUnitListContext.Provider>
  );
};
